import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function EvBatteryCoachBottomSheetPage() {
  const {t} = useInferableTranslation();
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className="bottom_sheet bottom_sheet_battery">
        <div className="bottom_sheet_header">
          <h2
            id="bottomSheetTitle"
            className="bottom_sheet_title"
          >
            {t('T30559')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label="close"
            onClick={() => (window as any).bottomSheetClose(null)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T30566')}</strong>
            <div className="battery_guide_box level_info_box">
              <span className="ic ic_master_s"></span>
              <div className="level_info">
                <span className="level_text">{t('T30560')}</span>
                <p className="status_desc">{t('T30567')}</p>
              </div>
            </div>
            <div className="battery_guide_box level_info_box">
              <span className="ic ic_guardian_s"></span>
              <div className="level_info">
                <span className="level_text">{t('T30562')}</span>
                <p className="status_desc">{t('T30568')}</p>
              </div>
            </div>
            <div className="battery_guide_box level_info_box">
              <span className="ic ic_saver_s"></span>
              <div className="level_info">
                <span className="level_text">{t('T30564')}</span>
                <p className="status_desc">{t('T30569')}</p>
              </div>
            </div>

            <ul className="notice_list">
              <li className="notice_item">{t('T30570')}</li>
              <li className="notice_item">{t('T30571')}</li>
              <li className="notice_item">{t('T30572')}</li>
              <li className="notice_item">{t('T30573')}</li>
            </ul>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default EvBatteryCoachBottomSheetPage;
